const APP_AUTO_SELECT_KEY = 'app_auto_select';
const PORTFOLIO_PREVIOUS_ROUTE_KEY = 'portfolio_previous_route';

export const PORTFOLIO_VALUATION = 'PORTFOLIO_VALUATION' as const;
export const DASHBOARD_409A = 'DASHBOARD_409A' as const;

export type AppAutoSelect = typeof PORTFOLIO_VALUATION | typeof DASHBOARD_409A;

export const saveAppAutoSelect = (app: AppAutoSelect): void => {
  localStorage.setItem(APP_AUTO_SELECT_KEY, app);
};

export const getAppAutoSelect = (): AppAutoSelect | null => localStorage.getItem(APP_AUTO_SELECT_KEY) as AppAutoSelect | null;

export const clearAppAutoSelect = (): void => {
  localStorage.removeItem(APP_AUTO_SELECT_KEY);
};

const portfolioRouteKey = (userId?: number) =>
  userId ? `${PORTFOLIO_PREVIOUS_ROUTE_KEY}_${userId}` : PORTFOLIO_PREVIOUS_ROUTE_KEY;

export const savePreviousPortfolioRoute = (route: string, userId?: number): void => {
  localStorage.setItem(portfolioRouteKey(userId), route);
};

export const getPreviousPortfolioRoute = (userId?: number): string | null =>
  localStorage.getItem(portfolioRouteKey(userId));

export const clearPreviousPortfolioRoute = (userId?: number): void => {
  localStorage.removeItem(portfolioRouteKey(userId));
};
